import { $playerProfile } from '../../../../backend/store';
import Settings from '../../../../settings/Settings';
import { TopUpVFX } from '../../vfx/topup/TopUpVFX';

const LABEL = {
    FONT: Settings.FONTS.LEAGUE_SPARTAN,
    SIZE: 50,
    TINT: 0xffffff,
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.5 },
    X: 90,
    OFFSET_Y: -3,
};

export default class HardCurrency extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private icon!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;
    public static globalPositionOfIcon: { x: number, y: number } = { x: 0, y: 0 }
    private vfx!: TopUpVFX;

    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.centerX;
        let y = 220;
        super(scene, x, y);

        this.setupBG();
        this.setupIcon();
        this.setupLabel();
        this.setupListeners();
    }

    setupBG() {
        let frame = 'gui/hard_currency/bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        // this.bg.setOrigin(0.5, 0.5);
        this.add(this.bg);
    }

    setupIcon() {
        const x = -this.bg.displayWidth / 2 + 25;
        const y = 0;

        let frame = 'gui/hard_currency/icon';

        this.icon = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.icon);

        HardCurrency.globalPositionOfIcon = { x: this.icon.getWorldTransformMatrix().tx, y: this.icon.getWorldTransformMatrix().ty }

        this.vfx = new TopUpVFX(this.scene, 5, 'gui/hard_currency/icon', { x: this.icon.getWorldTransformMatrix().tx, y: this.icon.getWorldTransformMatrix().ty }, { min: 50, max: 150 })
        this.scene.layers.popup_vfx.add(this.vfx);
    }

    vfxShow(startPoint: { x: number; y: number; }) {
        this.vfx.showTime(startPoint)
    }

    setupLabel() {
        let x = LABEL.X;
        let y = LABEL.OFFSET_Y;

        let hc = String($playerProfile.getState().player_wallet.currency_hard);

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, hc, LABEL.SIZE);
        this.label.setOrigin(1, 0.5);
        this.label.setTint(LABEL.TINT);
        this.label.setDropShadow(LABEL.SHADOW.X, LABEL.SHADOW.Y, LABEL.SHADOW.TINT, LABEL.SHADOW.ALPHA);
        this.add(this.label);
    }

    setupListeners() {
        $playerProfile.watch((state) => this.update(String(state.player_wallet.currency_hard)));
        this.scene.events.on('top_up_hard', this.vfxShow, this)
    }

    update(val: string) {
        this.label.setText(val);
    }

    destroy() {
        // this.scene.events.off(Session.EVENTS.GOLD_UPDATED, this.update, this);
    }
}

export { HardCurrency }